var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[{'adjust-with-sidebars':!_vm.local},'loader-container fixed bg-black bg-opacity-60 bottom-0 flex items-center justify-center left-0 right-0 text-6xl top-0 z-50']},[_c('i',{staticClass:"fas fa-circle-notch fa-spin fs-1"})])}
var staticRenderFns = []

export { render, staticRenderFns }